const map = {
	"./en/metric-affiliate.md": 1914,
	"./en/metric-direct.md": 224,
	"./en/metric-display-ads.md": 6844,
	"./en/metric-email.md": 6930,
	"./en/metric-gen-ai.md": 3714,
	"./en/metric-referral-sites.md": 9561,
	"./en/metric-search.md": 4809,
	"./en/metric-social-media.md": 5683,
	"./en/metric-traffic.md": 4928,
	"./ru/metric-affiliate.md": 7308,
	"./ru/metric-direct.md": 3702,
	"./ru/metric-display-ads.md": 830,
	"./ru/metric-email.md": 7263,
	"./ru/metric-gen-ai.md": 6856,
	"./ru/metric-referral-sites.md": 1607,
	"./ru/metric-search.md": 6667,
	"./ru/metric-social-media.md": 733,
	"./ru/metric-traffic.md": 2402
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8703;